<template>
  <v-card class="rounded-card">
    <template v-if="getAvailableAmountLoading === true || sleepLoading === true">
      <v-row no-gutters style="height: 276px">
        <v-card-title class="pa-4"> </v-card-title>
        <v-card-text class="pa-4 mt-3" style="height: 54px">
          <v-progress-linear rounded color="#6D6AFF" height="30" indeterminate>
            <span class="font--m-6"> 로딩중 </span>
          </v-progress-linear>
        </v-card-text>
        <v-card-text class="text-center font--m-5 pa-4" style="height: 54px">
          주문목록 기반으로 한도 산출 중입니다.
        </v-card-text>
        <v-row no-gutters>
          <v-card-text class="pa-4"> </v-card-text>
        </v-row>
      </v-row>
    </template>
    <template v-else>
      <available v-if="true" @refresh="refreshAmount"></available>
      <un-available v-else></un-available>
      <v-row no-gutters>
        <v-col cols="12" class="pa-4">
          <BasicButton
            id="btn__a+YWA12ofEethIYcpTQ6Xg=="
            :disabled="isService === false || storeAvailableAmount.available <= 0"
            :to="{ path: `/wholesaler/find` }"
            :classes="['btn__main-card']"
            height="42px"
          >
            <span class="font--m-2 color--white">사입비 송금하기</span>
          </BasicButton>
        </v-col>
      </v-row>
    </template>
  </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import Available from './card/Available.vue'
import UnAvailable from './card/UnAvailable.vue'
import { sleep } from '@/util'

export default {
  components: {
    Available,
    UnAvailable,
  },
  computed: {
    ...mapGetters('contract', {
      isService: 'isServiceAvailable',
    }),
    ...mapState('bnpl', {
      getAvailableAmountLoading: 'getAvailableAmountLoading',
      storeAvailableAmount: 'availableAmount',
    }),
  },
  data() {
    return {
      toolTipShow: true,
      sleepLoading: false,
      err: 0,
    }
  },
  async created() {
    await this.refreshAmount()
  },
  methods: {
    ...mapActions('bnpl', ['getAvailableAmount']),
    async refreshAmount() {
      try {
        await this.getAvailableAmount()
        this.err++
        this.sleepLoading = true
        await sleep(1500)
      } catch (e) {
        const confirm = await this.$swal.basic.confirm({
          html: `<p class="font--m-3">문제가 발생했어요. <br /> 잠시 후 다시 시도해주세요.</p><br /><p class="font--m-8">(동일 현상이 반복 될 경우 고객센터로 문의해주세요.)</p>`,
          cancelButtonText: '닫기',
          confirmButtonText: '다시 시도',
        })
        if (confirm.isConfirmed) {
          if (this.err > 2) {
            this.err = 0
            await this.$swal.basic.alert({
              html: `<p class="font--m-3">문제가 발생하여 고객센터로 문의해주세요.</p>`,
            })
            return
          }
          await this.refreshAmount()
          return
        }
      } finally {
        this.sleepLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn__main-card {
  border-radius: 10px;
}
.rounded-card {
  border-radius: 15px;
  background-color: $gray-15;
}
</style>
